import axios, { type AxiosError } from 'axios'

const baseUrl = String(process.env.REACT_APP_HUBSPOT_URL)
const hubSpotKey = String(process.env.REACT_APP_HUBSPOT_KEY)

interface CreateLead {
  handle: (params: CreateLead.Params) => Promise<CreateLead.Result>
}

export class HubSpotCreateLead implements CreateLead {
  async handle (params: CreateLead.Params): Promise<CreateLead.Result> {
    try {
      const data = {
        email: params.email,
        firstname: params.name,
        phone: params.phone,
        opt_in_comunicacao: params.optInCommunication ? 'true' : 'false',
        campanhas_adicionais: params.campanhasAdicionais
      }
      const response = await axios.post(baseUrl, data, { headers: { Authorization: `Bearer ${hubSpotKey}` } })
      return response
    } catch (err) {
      const error = err as AxiosError
      if (!error.response) throw error
      return error.response
    }
  }
}

export namespace CreateLead {
  export interface Params {
    email: string
    name: string
    phone: string

    optInCommunication: boolean

    campanhasAdicionais: 'lp_viva_sorte'
  }
  export interface Result {
    data: any
    status: number
  }
}
